import { deleteCookie, getCookie, setCookie } from "cookies-next/client";

import { TOKEN_COOKIE_NAME } from "../apiConfig";

const IDLE_TIMEOUT_IN_SECONDS = 4 * 60 * 60;

const cookieOptions = {
  path: "/",
  sameSite: "lax" as const,
  secure: process.env.NODE_ENV === "production",
};

const buildCookieStorage = (cookieName: string) => {
  const read = (): string | null => {
    const token = getCookie(cookieName);

    return typeof token === "string" && token !== "" ? token : null;
  };

  const save = (token: string): void => {
    setCookie(cookieName, token, {
      ...cookieOptions,
      maxAge: IDLE_TIMEOUT_IN_SECONDS,
    });
  };

  return {
    read,
    save,
    extend: (): void => {
      const token = read();

      if (token !== null) {
        save(token);
      }
    },
    clear: (): void => {
      deleteCookie(cookieName, cookieOptions);
    },
  };
};

export const tokenStorage = buildCookieStorage(TOKEN_COOKIE_NAME);
